/**
 * Parallax stack (spec 0100 / 0120) — fixed full-viewport layers + opaque content over gaps.
 * Uma variante por viewport. src só na layer ativa.
 */
(function () {
  'use strict';

  var gaps = document.querySelectorAll('[data-gm-px-stack-gap]');
  if (!gaps.length) return;

  var STACK_ID = 'gm-px-stack-root';
  if (document.getElementById(STACK_ID)) return;

  document.body.classList.add('gm-has-parallax-stack');

  var root = document.createElement('div');
  root.id = STACK_ID;
  root.className = 'gm-px-stack';
  root.setAttribute('aria-hidden', 'true');
  document.body.appendChild(root);

  var layersById = Object.create(null);
  var ratios = new Map();
  var activeId = null;
  var isMobile = window.matchMedia('(max-width: 749px)').matches;

  function makeImg(src, mod) {
    var img = document.createElement('img');
    img.className = 'gm-px-stack__img' + (mod ? ' gm-px-stack__img--' + mod : '');
    img.alt = '';
    img.decoding = 'async';
    img.loading = 'lazy';
    img.setAttribute('draggable', 'false');
    if (src) img.dataset.src = src;
    return img;
  }

  function hydrateLayer(layer) {
    if (!layer) return;
    var imgs = layer.querySelectorAll('img[data-src]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (!img.getAttribute('src')) {
        img.src = img.dataset.src;
      }
    }
  }

  for (var i = 0; i < gaps.length; i++) {
    var gap = gaps[i];
    var id = gap.getAttribute('data-gm-px-id') || String(i);
    var src = gap.getAttribute('data-gm-px-src') || '';
    var srcMobile = gap.getAttribute('data-gm-px-src-mobile') || '';
    var grayscale = gap.getAttribute('data-gm-px-grayscale') === '1';

    var layer = document.createElement('div');
    layer.className = 'gm-px-stack__layer' + (grayscale ? ' gm-px-stack__layer--grayscale' : '');
    layer.dataset.gmPxId = id;

    if (srcMobile) {
      if (isMobile) {
        layer.appendChild(makeImg(srcMobile, 'mobile'));
      } else {
        layer.appendChild(makeImg(src, 'desktop'));
      }
    } else {
      layer.appendChild(makeImg(src, ''));
    }

    root.appendChild(layer);
    layersById[id] = layer;
    ratios.set(gap, 0);
  }

  function setActive(id) {
    if (id === activeId) return;
    activeId = id;
    var keys = Object.keys(layersById);
    for (var k = 0; k < keys.length; k++) {
      var lid = keys[k];
      var layer = layersById[lid];
      if (lid === id) {
        hydrateLayer(layer);
        layer.classList.add('is-active');
      } else {
        layer.classList.remove('is-active');
      }
    }
  }

  function clearActive() {
    if (activeId === null) return;
    activeId = null;
    var keys = Object.keys(layersById);
    for (var k = 0; k < keys.length; k++) {
      layersById[keys[k]].classList.remove('is-active');
    }
  }

  function pickBest() {
    var bestGap = null;
    var bestRatio = 0;
    for (var i = 0; i < gaps.length; i++) {
      var g = gaps[i];
      var r = ratios.get(g) || 0;
      if (r > bestRatio) {
        bestRatio = r;
        bestGap = g;
      }
    }
    if (!bestGap || bestRatio <= 0) {
      clearActive();
      return;
    }
    var id = bestGap.getAttribute('data-gm-px-id');
    if (id) setActive(id);
  }

  if (typeof IntersectionObserver !== 'function') {
    var fallbackId = gaps[0].getAttribute('data-gm-px-id');
    if (fallbackId) setActive(fallbackId);
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var e = entries[i];
        ratios.set(e.target, e.isIntersecting ? e.intersectionRatio : 0);
      }
      pickBest();
    },
    {
      threshold: [0, 0.05, 0.1, 0.25, 0.5, 0.75, 1],
      rootMargin: '15% 0px 15% 0px'
    }
  );

  for (var j = 0; j < gaps.length; j++) {
    io.observe(gaps[j]);
  }
})();
